import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import "../../styles-arabic/learn-more.rtl.css";

const faqs = [
  {
    question: "ما الذي يمكنني البحث عنه في الأرشيف؟",
    answer:
      "يمكنكم البحث في الصحف والكتب والمجلات والمنشورات العربية من مجتمعات العرب في أمريكا الشمالية والجنوبية.",
  },
  {
    question: "كيف يمكنني تضييق نتائج البحث؟",
    answer:
      "استخدموا المرشحات المتاحة لتضييق النتائج حسب السنة واسم المنشور ومكان النشر وتفاصيل الوثيقة الأخرى.",
  },
  {
    question: "هل يمكنني التصفح بدلاً من البحث؟",
    answer:
      "نعم. استخدموا روابط تصفح الدوريات والكتب والمجموعات لاستكشاف الأرشيف من دون إدخال عبارة بحث.",
  },
  {
    question: "كيف أبلغ عن مشكلة أو أقترح منشوراً؟",
    answer:
      "راسلوا فريق مركز خيرالله على lebanesestudies@ncsu.edu للأسئلة أو التصحيحات أو اقتراحات المنشورات.",
  },
];

const FAQArabic = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="background">
        <div className="learn-more-shell" dir="rtl">
          <button
            className="learn-more-back-button"
            onClick={() => window.history.back()}
            type="button"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>العودة</span>
          </button>

          <header className="learn-more-titlebar">
            <h1 className="learn-more-header">الأسئلة الشائعة</h1>
            <hr className="line" />
          </header>

          <section className="faq-list" aria-label="الأسئلة الشائعة">
            {faqs.map((item) => (
              <article className="faq-item" key={item.question}>
                <h2>{item.question}</h2>
                <p className="paragraph">{item.answer}</p>
              </article>
            ))}
          </section>
        </div>
      </div>
      <Footer bgcolor="#fff" />
    </>
  );
};

export default FAQArabic;
